module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "功能名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.name),
      expression: "form.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        _vm.form.name = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权限标识",
      "prop": "rule"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.rule_name),
      expression: "form.rule_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": (_vm.form.rule_name)
    },
    on: {
      "input": function($event) {
        _vm.form.rule_name = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关联表单",
      "prop": "model"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.model_name),
      expression: "form.model_name"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": (_vm.form.model_name)
    },
    on: {
      "input": function($event) {
        _vm.form.model_name = $event
      }
    }
  })]), _vm._v(" "), _vm._t("self-config"), _vm._v(" "), _vm._t("import-config"), _vm._v(" "), (_vm.isLimit) ? _c('el-form-item', {
    attrs: {
      "label": "可用条件",
      "prop": "has_condition"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.has_condition),
      expression: "form.has_condition"
    }],
    domProps: {
      "value": (_vm.form.has_condition)
    },
    on: {
      "input": function($event) {
        _vm.form.has_condition = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("无限制")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("条件限制")])])]) : _vm._e(), _vm._v(" "), (_vm.showCondition && _vm.isLimit) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "可用",
      "prop": "has_condition"
    }
  }, [_c('condition-table', {
    attrs: {
      "condition": _vm.form.condition.visible,
      "inputList": _vm.inputList
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "不可见",
      "prop": "has_condition"
    }
  }, [_c('condition-table', {
    attrs: {
      "condition": _vm.form.condition.invisible,
      "inputList": _vm.inputList
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "禁用",
      "prop": "has_condition"
    }
  }, [_c('condition-table', {
    attrs: {
      "condition": _vm.form.condition.forbiden,
      "inputList": _vm.inputList
    }
  })])]) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d6c82cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/commonConfig.vue
// module id = 1964
// module chunks = 2